import { ElementType } from 'react';
import { HeroBanner } from '@ahmdigital/ui';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';

import { CONTENT_SECTIONS } from './content/sections';
import Award from '../insurance/components/award';
import CommonQuestions from '../insurance/components/common-questions';
import ContactDetails from './components/contact-details';
import ContentTilesSection from '../../components/content-tiles-section';
import ExternalContent from '../insurance/external-content';
import FindCoverSection from '../media-landing/components/find-cover-section';
import getContentToRender from './utils/get-content-to-render';
import Head from '../../../utils/head';
import Inclusions from '../insurance/components/inclusions';
import OfferBanner from '../../components/offers/banner';
import PageSections from './components/page-sections';
import ProductsSection from '../../components/sections/products-section';
import RequestACallDrawer from '../../components/request-a-call/drawer';
import SummaryWithImageSection from '../explained-term/detail/components/summary-with-image-section';
import TermsAndConditions from '../insurance/components/terms-and-conditions';
import ValuePropositions from '../insurance/components/value-propositions';
import YouthDiscountSlider from './components/youth-discount-slider';

const getComponents = () =>
  ({
    [CONTENT_SECTIONS.AWARD]: Award,
    [CONTENT_SECTIONS.HEADER]: HeroBanner,
    [CONTENT_SECTIONS.OFFER]: OfferBanner,
    [CONTENT_SECTIONS.VALUE_PROPOSITIONS]: ValuePropositions,
    [CONTENT_SECTIONS.SELLING_POINTS_GROUP]: Inclusions,
    [CONTENT_SECTIONS.PROMOTIONAL_TILES]: ContentTilesSection,
    [CONTENT_SECTIONS.CONTACT_DETAILS]: ContactDetails,
    [CONTENT_SECTIONS.COMMON_QUESTIONS]: CommonQuestions,
    [CONTENT_SECTIONS.PRODUCT_LIST]: ProductsSection,
    [CONTENT_SECTIONS.PRODUCT_LIST_SECTION]: FindCoverSection,
    [CONTENT_SECTIONS.EXTERNAL_CONTENT]: ExternalContent,
    [CONTENT_SECTIONS.TOPIC_GROUP]: SummaryWithImageSection,
    [CONTENT_SECTIONS.TERMS_AND_CONDITIONS]: TermsAndConditions,
    [CONTENT_SECTIONS.YOUTH_DISCOUNT_SLIDER]: YouthDiscountSlider,
  }) as Record<string, ElementType>;

type ConsiderationLandingPageProps = {
  content: ReturnType<typeof getContentToRender> | null;
};

const ConsiderationLandingPage = ({ content }: ConsiderationLandingPageProps) => {
  const metadataObject = content?.considerationContent?.metadataObject;
  const title = metadataObject?.name || '';
  const description = metadataObject?.descriptionRaw || '';
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={portableTextToPlain(description)} />
      </Head>
      <PageSections components={getComponents()} content={content} />
      <RequestACallDrawer />
    </>
  );
};

export default ConsiderationLandingPage;
